// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "ad_optimization_recommendation".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "ad_optimization_recommendation" table (1:1 with a DB row, on the wire). */
export const adOptimizationRecommendationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    adAccountId: z.string().nullable(),
    metaCampaignId: z.string().nullable(),
    metaAdSetId: z.string().nullable(),
    subjectType: z.string(),
    subjectId: z.string(),
    rule: z.string(),
    action: z.string(),
    severity: z.string(),
    reason: z.string(),
    evidence: z.unknown(),
    rulesVersion: z.string(),
    mode: z.string(),
    evaluatedFor: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=adOptimizationRecommendation.js.map